module.exports = __webpack_public_path__ + "assets/img/14_1004_big.5235a4ff.jpg";